import { generateUseContext } from '@guiker/react-framework'

import { InvoiceContext } from '../context'

export const useInvoiceContext = generateUseContext(InvoiceContext)
